import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { Constants } from 'app/shared/shared-constants';
import { format } from 'app/shared/utils/string.util';
import { maxConcurrentConnectionsMetadata, preCopyScriptMetadata } from '../consts/metadata-consts';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

export const relationalTableMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.relationalTable.datasetType,
    displayName: stringResources.RelationalTable_DisplayText,
    supportLinkedServiceTypes: [
        adfModelTypeMap.amazonRedshift.linkedServiceType,
        adfModelTypeMap.db2.linkedServiceType,
        adfModelTypeMap.mysql.linkedServiceType,
        adfModelTypeMap.odbc.linkedServiceType,
        adfModelTypeMap.postgreSql.linkedServiceType,
        adfModelTypeMap.sapBw.linkedServiceType,
        adfModelTypeMap.sapHana.linkedServiceType,
        adfModelTypeMap.sybase.linkedServiceType,
        adfModelTypeMap.teradata.linkedServiceType
    ],
    isSource: true,
    isSink: true,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-PlaceHolderDatabase'
    },
    isFirstClass: true,
    category: ['Database'],
    copySourceControls: [],
    copySinkControls: [
        preCopyScriptMetadata(),
        {
            type: 'parameterizable',
            child: {
                type: 'textbox',
                bind: 'writeBatchTimeout',
                label: stringResources.ModelName_WriteBatchTimeout,
                validators: [
                    {
                        type: 'pattern',
                        pattern: Constants.timeoutValidationPattern,
                        errorMessage: format(stringResources.InvalidTimeoutPattern, stringResources.ModelName_WriteBatchTimeout)
                    }
                ]
            },
            dynamicContentTextClass: 'input-spaced'
        },
        {
            type: 'parameterizable',
            child: {
                type: 'textbox-number',
                bind: 'writeBatchSize',
                label: stringResources.ModelName_WriteBatchSize,
                inputType: 'number',
                defaultValue: 0,
                min: 0
            },
            dynamicContentTextClass: 'input-spaced'
        },
        maxConcurrentConnectionsMetadata
    ]
};
